<template>
	<div class="sites-dashboard">
		<UserMenu />
		<div class="main-panel">
			<TopNav />
			<Outages />
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
export default {
  name: "sites",
  components: {
    UserMenu: () =>
      import(/* webpackChunkName: "userMenu" */ "../../../components/User/SideMenu.vue"),
    TopNav: () =>
      import(/* webpackChunkName: "topNav" */ "../../../components/TopNav.vue"),
	Outages: () =>
		import(/* webpackChunkName: "supportTicketsList" */ "../../../components/Helps/OutageBanner.vue")
  }
};
</script>
